import * as types from '../constants/actionTypes/saving';
import saveTimeout from '../common/saveTimeout';

// eslint-disable-next-line import/prefer-default-export
export const updateSavingStatus = (status) => (dispatch) => {
    if (status) {
        saveTimeout.set(dispatch);
    }
    dispatch({
        type: types.UPDATE_SAVING_STATUS,
        payload: status,
    });
};
